import React from 'react';
import { useTranslation } from 'react-i18next';
import { DefaultCard } from "../Card/Card";

const AppointmentDetailActions = ({ onClick, onNoAnswerClick, onBuyClick, leadType, onBusyClick }) => {
    const {t} = useTranslation();
    return <DefaultCard title={t('appointmentdetailactions.actions')}>
            <div className="d-flex gap-8 align-items-center flex-wrap">
                <button className="btn btn-default btn-sm" onClick={() => onBusyClick()}>{t('appointmentdetailactions.busy')}</button>
                <button className="btn btn-default btn-sm" onClick={() => onNoAnswerClick()}>{t('appointmentdetailactions.noanswer')}</button>
                <button className="btn btn-default btn-sm" onClick={() => onClick("showSendEmailModal")}>{t('appointmentdetailactions.sendemail')}</button>
                {leadType !== "aoLead" && <button className="btn btn-sm" onClick={() => onBuyClick("order")}>{t('appointmentdetailactions.placeorder')}</button>}
                {leadType !== "aoLead" && <button className="btn btn-sm" onClick={() => onBuyClick("close")}>{t('appointmentdetailactions.closebought')}</button>}
                {leadType === "aoLead" && <button className="btn btn-default btn-sm" onClick={() => onBuyClick("close")}>{t('appointmentdetailactions.buy')}</button>}
                <button className="btn btn-default btn-sm" onClick={() => onClick("showCloseModal")}>{t('appointmentdetailactions.close')}</button>
            </div>
        </DefaultCard>
}

export default AppointmentDetailActions;